import * as React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import Subtitle from '../onlineSubtitle/onlineSubtitle';

// tslint:disable-next-line:variable-name
const SDropdownWrap = styled.div<{ noPadding: boolean }>`
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  ${({ noPadding }) => (noPadding ? '' : 'padding: 5px;')};
  @media only screen and (min-width: 800px) {
    flex-basis: 0;
  }
`;

// tslint:disable-next-line:variable-name
const SDropdown = styled(Select)<{ error: string }>(({ theme, error }) => ({
  position: 'relative',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,

  '*': {
    fontFamily: theme.font.family,
  },

  '.dropDown__control': {
    backgroundColor: theme.colors.whiteGray,
    border: `solid ${error ? `${theme.colors.error} 1.5px` : `transparent 1px`}`,
    borderRadius: theme.borderRadiusCommon,
    position: 'relative',
    cursor: 'pointer',
    height: '100%',
    boxShadow: 'none' /* override  */,
    '&:hover': {
      border: `solid ${error ? `${theme.colors.error} 1.5px` : `transparent 1px`}`,
    },
  },
  '.dropDown__value-container': {
    fontWeight: theme.font.weight.normal,
    fontSize: '14px',
    boxSizing: 'border-box',
    color: '#777',
    backgroundColor: 'transparent',
    borderWidth: 0,
    padding: `0px ${theme.spacing.larger}px`,
    div: {
      margin: 0,
      padding: 0,
      fontWeight: theme.font.weight.medium,
      fontSize: theme.font.size.smallMedium,
      color: theme.colors.primaryBackground,
      fontFamily: 'Poppins',
    },
    input: {
      width: '100%',
      appearance: 'none',
      outline: 'none',
      margin: 0,
      padding: 0,
      borderWidth: 0,
      fontSize: theme.font.size.smallMedium2,
    },
  },
  '.dropDown__placeholder': {
    fontWeight: theme.font.weight.medium,
    color: `${theme.colors.placeholderGray}!important`,
    fontSize: theme.font.size.smallMedium2,
    position: 'absolute',
    margin: 0,
    top: 'auto',
    transform: 'initial',
    div: {
      margin: 0,
    },
  },
}));

const ErrorSubtitle = styled(Subtitle)`
  color: red;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0;
  ${({ initErrorSpacing }: { initErrorSpacing: boolean }) => initErrorSpacing && 'min-height: 18px'}
`;

export interface IDropdownOptionForSelect<T> {
  label: string;
  value: T;
}

export interface IDropdownProps<T> {
  onChange: (selectedOption: T, name: string) => void;
  name: string;
  placeholder?: string;
  value: T;
  dropdownOptions: Array<IDropdownOptionForSelect<T>>;
  dataAt?: string;
  className?: string;
  label?: string | React.ReactChild;
  tooltipContent?: string;
  error?: string;
  noPadding?: boolean;
  initErrorSpacing?: boolean;
  dataTestId?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
}

export class Dropdown<T> extends React.Component<IDropdownProps<T>> {
  public handleOnChange = (selectedOption: IDropdownOptionForSelect<T>) => {
    this.props.onChange(selectedOption.value, this.props.name);
  };

  private renderError = () => {
    const { error, initErrorSpacing } = this.props;

    if (error || initErrorSpacing)
      return (
        <ErrorSubtitle {...{ className: 'error', dataTestId: 'error-message', initErrorSpacing }}>
          {error}
        </ErrorSubtitle>
      );

    return null;
  };

  public render() {
    const { dataTestId, dataAt, className, noPadding, isDisabled, isLoading } = this.props;

    const placeholder = this.props.placeholder || this.props.name.replace(/^\w/, (c) => c.toUpperCase());
    let selecedOption = null;

    if (this.props.value && this.props.dropdownOptions && this.props.dropdownOptions.length) {
      selecedOption = this.props.dropdownOptions.find((item) => {
        return item.value === this.props.value;
      });
    }

    return (
      <SDropdownWrap
        {...{
          className,
          'data-testid': dataTestId,
          'data-at': dataAt,
          noPadding: !!noPadding,
        }}
      >
        <SDropdown
          classNamePrefix="dropDown"
          /*@ts-ignore*/
          dataAt={`${this.props.dataAt}-select`}
          options={this.props.dropdownOptions}
          placeholder={placeholder}
          onChange={this.handleOnChange}
          value={selecedOption}
          error={this.props.error || ''}
          {...{ isDisabled, isLoading }}
        />
        {this.renderError()}
      </SDropdownWrap>
    );
  }
}
